import * as XLSX from 'xlsx';

export const DownloadPackages = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
        alert('No data available to download!');
        return;
    }

    try {
        // Preprocess the data to include only 'name' and 'phone'
        const filteredData = data.map((item,index) => ({
            "SN": index+1,
            "Creation Date": new Date(item.createdAt).toLocaleString(),
            "Agency Name": item.agencyName,
            "Package": item.packageName,
            "Price Range": `${item.minPrice?.toLocaleString()} PKR - ${item.maxPrice?.toLocaleString()} PKR` ,
            "Package's Bookings": item.totalBookings,
            "Package's Status": item.isActive?"Active":"Inactive",
        }));

        // Step 1: Convert JSON data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(filteredData);

        // Step 2: Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Agencies Packages');

        // Step 3: Export the workbook as an Excel file
        const fileName = 'Agencies Packages.xlsx';
        XLSX.writeFile(workbook, fileName);
       
    } catch (error) {
        console.error('Error while exporting data to Excel:', error);
        alert('An error occurred while downloading the Excel file.');
    }
};
